import React, {
  Fragment,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  createRef,
  forwardRef,
} from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../CustomedFields/FormikControl";
import customerServices from "./../../services/customerServices";
import { useContext } from "react";
import OrderContext from "./../../store/order-context";
import DropdownSearchable from "./../../Utils/DropDownSearchable";
import useTranslation from "./../../customHooks/translations";
import { NotificationManager } from "react-notifications";

import { useSelector, useDispatch } from "react-redux";
// import { addCustomerInfo, clearCustomerInfo } from "./../../slice/orderSlice";
import { addCustomerInfo } from "./../../slice/orderSlice";

// function CustomerAdd(props, ref) {
const CustomerAdd_emb = React.forwardRef((props) => {
  const dispatch = useDispatch();
  //Get state from store
  const { customerStore, isLoadingStore } = useSelector((state) => state.order);
  const translation = useTranslation();
  // alert("props.customer?.name => " + props.customer?.name);

  //   const date = new Date();
  //   const futureDate = date.getDate() + 3;
  //   date.setDate(futureDate);
  //  const defaultValue = date.toLocaleDateString("en-CA");

  const [customer, setCustomer] = useState(props.customer);

  const { name, cellNo, alternetPhone, email, address, registeredDate } =
    customer;
  const onInputChange = (e) => {
    setCustomer({ ...customer, [e.target.name]: e.target.value });
  };

  const initialValues = {
    // name: "",
    // cellNo: "",
    // alternetPhone: "",
    // email: "",
    // address: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
    cellNo: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email format"),
    // courseDate: Yup.date().required("Required").nullable(),
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    // alert("submit");
    if (customer?.name === "") {
      NotificationManager.warning(
        "Please enter customer name",
        "Warning",
        4000
      );
      return;
    }

    if (customer?.cellNo === "") {
      NotificationManager.warning(
        "Please enter customer phone number",
        "Warning",
        4000
      );
      return;
    }

    console.log("Form data  customer ====>", customer);
    let savedCustomer = await customerServices.save(customer);
    if (savedCustomer !== "undefined" || savedCustomer !== null) {
      props.savedCustomer(savedCustomer);
    }
  };

  const handleSubmit = (e) => {
    // Not used anywhere.
    console.log("Form data---");
  };

  // const onSubmit = (event) => {
  //   alert("Form submitted");
  //   event.preventDefault();
  //   //Your code here. For example,
  // };

  //********************* Form validation send to Parent form */
  // React.useEffect(() => {
  //   // Update the document title using the browser API
  //   // alert("document.getElementById(submitButton).disabled");
  //   // props.isValidChildFormInputs(
  //   //   document.getElementById("submitButton")?.disabled
  //   // );
  // }, [document.getElementById("submitButton")?.disabled]);

  console.log("props.customer  =====> " + props.customer?.name);

  //***    Search Customer  */
  const optionsForCustomerDDLTemp = [
    // "Apple",
    // "Banana",
    // "Cherry",
    // "Date",
    // "Fig",
    // "Grape",
    // "Lemon",
    // "Orange",
    // "Peach",
    // "Pear",
    // "Pineapple",
  ];

  const [loadingVar, setLoadingVar] = useState(false);
  const [optionsForCustomerDDL, setOptionsForCustomerDDL] = useState(
    optionsForCustomerDDLTemp
  );
  const [enteredSearchField, setEnteredSearchField] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [selectedSearchStyle_Customer, setSelectedSearchStyle_Customer] =
    useState();
  const [selectedSearchStyle_Order, setSelectedSearchStyle_Order] = useState();
  const [selectedSearchStyle_TrackingNo, setSelectedSearchStyle_TrackingNo] =
    useState();

  const [rowNumber, setRowNumber] = useState(0);

  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    //** Dont' run for First time */
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    if (enteredSearchField.length <= 3) {
      console.log("Need to enter more than 4 char.........");
      return () => {
        // console.log("clear timeout");
        // clearTimeout(identifier);
      };
    }
    console.log("after null.......");

    //(1) search
    const identifier = setTimeout(async () => {
      // debugger;
      setLoadingVar(true);
      await onSearch_SetCustomerList();
      setLoadingVar(false);
      // console.log("customerListHtml" + customerListHtml);
    }, 1500);

    // 1. Search type - customer
    const onSearch_SetCustomerList = async () => {
      console.log("Load Customer search-------");
      let customerSearched = await customerServices.searchNameOrPhone(
        enteredSearchField
      );
      // debugger;
      console.log("searched customer ----------> " + customerSearched);
      clearAllStateVariable();
      if (customerSearched == null) {
        // setCustomerList([]);
      } else {
        setCustomerList(customerSearched);
        setOptionsForCustomerDDL(customerSearched);
      }
    };

    const clearAllStateVariable = () => {
      setRowNumber(0);
      setCustomerList([]);
      setOptionsForCustomerDDL([]);
      dispatch(addCustomerInfo(null));
    };

    // (2) clear setTime out
    return () => {
      console.log("clear timeout");
      clearTimeout(identifier);
    };
  }, [enteredSearchField]);

  const onSelectedItemID = (selectedItemID) => {
    console.log("onSelectedItemID :: " + selectedItemID);
  };

  const onSelectedItem = (selectedItem) => {
    console.log("selected item.. :: " + selectedItem?.name);
    if (selectedItem !== "undefined" || selectedItem !== null) {
      props.savedCustomer(selectedItem);
    }
  };

  const ddlStyle = {
    width: "300px",
  };

  return (
    <>
      <div style={{ backgroundColor: "lightgreen" }}>
      <div style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', color: 'skyblue' }}>
        {translation.Customer_Information}
      </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          // onSubmit={onSubmit}
          onSubmit={(values) => {
            console.log("values of form submit: " + values);
          }}
          enableReinitialize={true}
        >
          {({ values, handleSubmit, isSubmitting, errors, touched }) => {
            {
              /* 
        //NOTE: alternet
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
          isSubmitting,
        }) => { */
            }
            return (
              <Fragment>
                <form
                  // role="form"
                  onSubmit={(e) => {
                    console.log("e, values => : " + e);
                    // alert("e, values => : " + e);
                    //handleSubmit(e);
                    onSubmit(e);
                    // e.preventDefault();
                  }}
                >
                  <div style={{ marginLeft: "115px" }}>
                    <div style={{ float: "left" }}>
                      <h4>Find Customer</h4>
                      <DropdownSearchable
                        onselectedItemID={onSelectedItemID}
                        onSelectedItem={onSelectedItem}
                        setEnteredSearchField={setEnteredSearchField}
                        options={optionsForCustomerDDL}
                        placeholder={translation.search_customers}
                        isLoading={loadingVar}
                        style={ddlStyle}
                      />
                    </div>
                    <div
                      style={{
                        float: "left",
                        marginLeft: "100px",
                        backgroundColor: "pink",
                        padding: "5px",
                        fontWeight: "bolder",
                        color: "",
                      }}
                    >
                      {" "}
                      {customerStore && <span>EDIT CUTOMER</span>}
                      {customerStore === null && <span>ADD NEW CUTOMER</span>}
                    </div>
                    <div style={{ clear: "both" }}></div>

                    <div style={{ width: "50px", float: "left" }}>
                      <img
                        style={{ width: "50px", height: "50px" }}
                        className="mr-3 rounded-circle"
                        src="./../../../public/images/avatar/avatar.png"
                      />
                    </div>
                    <div
                      style={{
                        width: "78%",
                        float: "left",
                        marginLeft: "15px",
                      }}
                    >
                      <div style={{ width: "250px", float: "left" }}>
                        <FormikControl
                          control="Input_customer_emb"
                          type="text"
                          label="Name"
                          name="name"
                          value={name}
                          onChange={(e) => onInputChange(e)}
                        />
                      </div>
                      <div style={{ width: "150px", float: "left" }}>
                        <FormikControl
                          control="Input_customer_emb"
                          type="text"
                          label="Cell No"
                          name="cellNo"
                          value={cellNo}
                          onChange={(e) => onInputChange(e)}
                        />
                      </div>
                      <div style={{ width: "150px", float: "left" }}>
                        <FormikControl
                          control="Input_customer_emb"
                          type="text"
                          label="Alternet Phone"
                          name="alternetPhone"
                          value={alternetPhone}
                          onChange={(e) => onInputChange(e)}
                        />
                      </div>
                      <div style={{ clear: "both" }}></div>

                      <div style={{ width: "150px", float: "left" }}>
                        <FormikControl
                          control="input"
                          type="date"
                          label="Registration Date"
                          name="registeredDate"
                          dateFormat="dd/MM/yyyy"
                          value={registeredDate}
                          // defaultValue={defaultValue}
                          onChange={(e) => onInputChange(e)}
                        />
                      </div>
                      <div style={{ width: "250px", float: "left" }}>
                        <FormikControl
                          control="Input_customer_emb"
                          type="text"
                          label="Address"
                          name="address"
                          value={address}
                          onChange={(e) => onInputChange(e)}
                        />
                      </div>
                      <div style={{ width: "150px", float: "left" }}>
                        <FormikControl
                          control="Input_customer_emb"
                          type="text"
                          label="Email"
                          name="email"
                          value={email}
                          onChange={(e) => onInputChange(e)}
                        />

                        {/* <button
                        id="submitButton"
                        type="submit"
                        disabled={!formik.isValid || !formik.touched.CellNo}
                        ref={ref}
                      >
                        Submit
                      </button> */}
                      </div>
                    </div>
                    <div style={{ width: "50px", float: "right" }}>
                      <span className="float-right">
                        {/* {props.lstMeasurementDetail.length} */}{" "}
                        <div className="btn-group m-b-20">
                          <button
                            onClick={() => {
                              props.clearCustomerInfo();
                            }}
                            type="button"
                            className="btn btn-light"
                          >
                            ADD NEW bbbb
                          </button>

                          {(props.mode === 1 || props.mode === 2) && (
                            <button
                              id="submitButton"
                              type="submit"
                              disabled={!touched}
                              // disabled={
                              //   //** NOTE: alternet way */
                              //   // errors || isSubmitting ||!touched
                              //   !formik.isValid ||
                              //   !formik.dirty ||
                              //   formik.isSubmitting
                              // }
                              // disabled={!formik.isValid || !formik.touched.CellNo}
                              // ref={ref}
                              className="btn btn-light"
                            >
                              <i className="fa fa-save"></i>
                            </button>
                          )}
                          <button
                            // onClick={() => {
                            //   handleClickDelete(props.indexEntry);
                            // }}
                            type="button"
                            className="btn btn-light"
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      </span>
                    </div>
                    <div className="clearBoth"></div>
                  </div>
                </form>
              </Fragment>
            );
          }}
        </Formik>
      </div>
    </>
  );
});

export default CustomerAdd_emb;
